import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BASE_URL = `${process.env.REACT_APP_LINK}`;
const formatPrice = (value) => {
  const num = Number(value);
  if (isNaN(num) || num <= 0) return 'N/A';

  if (num >= 1e7) {
    return `${(num / 1e7).toFixed(2)} Crore`;
  } else if (num >= 1e5) {
    return `${(num / 1e5).toFixed(2)} Lakh`;
  } else {
    return num.toLocaleString('en-IN'); // fallback for values < 1 Lakh
  }
};

const getPriceAndAreaDetails = (flatTypeArray) => {
  let smallest = null;
  let largest = null;

  flatTypeArray.forEach(ft => {
    if (Array.isArray(ft.builtUpAreas)) {
      ft.builtUpAreas.forEach(area => {
        const price = parseFloat(area.expectedPrice || 0);
        if (!isNaN(price) && price > 0) {
          if (!smallest || price < parseFloat(smallest.expectedPrice)) smallest = area;
          if (!largest || price > parseFloat(largest.expectedPrice)) largest = area;
        }
      });
    }
  });

  return { smallest, largest };
};
const PremiumPicks = () => {
  const [activeCity, setActiveCity] = useState('Mumbai');
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [propertyFilter, setPropertyFilter] = useState("All");

  // const cities = ['Gurugram', 'Noida'];
  const cities = [...new Set(properties.map(p => p.city))];

  const parseJSON = (val) => {
    try {
      return typeof val === 'string' ? JSON.parse(val) : val;
    } catch {
      return val;
    }
  };



  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);

        const [res1, res2, res3] = await Promise.all([
          fetch(`${BASE_URL}/resident/getproperty/HBTR0001`),
          fetch(`${BASE_URL}/commercial/getproperty/HBTR0001`),
          fetch(`${BASE_URL}/rentresident/getproperty/HBTR0001`)
        ]);

        const [json1, json2, json3] = await Promise.all([
          res1.json(),
          res2.json(),
          res3.json()
        ]);

        const parseProps = (item) => {
          const parseJSON = (val) => {
            try {
              return typeof val === 'string' ? JSON.parse(val) : val;
            } catch {
              return val;
            }
          };
          return {
            amenities: parseJSON(item.amenities || "[]"),
            carpetArea: parseJSON(item.carpetArea || "[]"),
            flatType: parseJSON(item.flatType || "[]"),
            expectedPrice: parseJSON(item.expectedPrice || "[]"),
            formImages: parseJSON(item.formImages || "[]"),
            locationAdvantage: parseJSON(item.locationAdvantage || item.locationAdvantages || "[]"),
          };
        };

        const combined = [
          ...json1.map(item => ({ ...item, type: "resident", ...parseProps(item) })),
          ...json2.map(item => ({ ...item, type: "commercial", ...parseProps(item) })),
          ...json3.map(item => ({ ...item, type: "rent", ...parseProps(item) }))
        ];

        const uniqueData = combined.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.property_id === value.property_id)
        );

        const sortedData = uniqueData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setProperties(sortedData);
      } catch (err) {
        setError('Failed to fetch properties. Please try again later.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  const filteredProperties = properties
    .filter(
      (item) => (item.city || "").toLowerCase() === activeCity.toLowerCase()
    )
    .filter((item) => {
      if (propertyFilter === "All") return true;
      return item.typeofproperty === propertyFilter;
    });


  const handlePageChange = (propertyId, propertType) => {
    console.log(propertyId, propertType)
    if (propertType === "Residential") {
      navigate(`/residential-property/${propertyId}`);
    } else if (propertType === "Commercial") {
      navigate(`/commercial-property/${propertyId}`);
    } else if (propertType === "Rent Residential") {
      navigate(`/rent-property/${propertyId}`);
    }
  };


  return (
    <section className="premium-picks-container">
      <div className="header-content">
        <h2 className="section-title">Best Picks</h2>
        <p className="section-subtitle">Explore the premium homes across Mumbai.</p>
      </div>

      <div className='flex-divcitynew'>
        <div className="city-tabs">
          {cities.map((city) => (
            <button
              key={city}
              className={`tab-button ${activeCity === city ? 'active' : ''}`}
              onClick={() => setActiveCity(city)}
            >
              {city}
            </button>
          ))}
        </div>
        <div>
          <select
            value={propertyFilter}
            onChange={(e) => setPropertyFilter(e.target.value)}
            className="property-filter-select"
          >
            <option value="All">All</option>
            <option value="Residential">Residential</option>
            <option value="Commercial">Commercial</option>
            <option value="Rent Residential">Rent</option>
          </select>
        </div>
      </div>
      {/* <div className="premium-filter-bar">
        <select
          value={propertyFilter}
          onChange={(e) => setPropertyFilter(e.target.value)}
          className="property-filter-select"
        >
          <option value="All">All</option>
          <option value="Residential">Residential</option>
          <option value="Commercial">Commercial</option>
          <option value="Rent Residential">Rent</option>
        </select>
      </div> */}


      <div className="property-grid">
        {loading ? (
          <div className="loading">Loading properties...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : filteredProperties.length === 0 ? (
          <div className="no-properties">No properties found for {activeCity}.</div>
        ) : (
          filteredProperties.map((item, index) => {
            const { smallest, largest } = getPriceAndAreaDetails(item.flatType);
            return <div key={item.property_id || index} className="property-card" onClick={() => handlePageChange(item.property_id, item.typeofproperty)}>
              <div className="image-wrapper">
                <img
                  src={item.formImages && item.formImages.length > 0 ? `${process.env.REACT_APP_IMAGE_BASE_URL}/Images/Store/${item.formImages[0]}` : '/placeholder-image.jpg'}
                  alt={item.building_name}
                />
              </div>
              <div className="card-details">
                <h3>{item.building_name}</h3>
                <p className="location">{item.address}</p>
                <p className="price">Starting From  {smallest?.expectedPrice > 0 && largest?.expectedPrice > 0 ? (
                  smallest.expectedPrice === largest.expectedPrice ? (
                    `₹ ${formatPrice(smallest.expectedPrice)}`
                  ) : (
                    `₹ ${formatPrice(smallest.expectedPrice)} - ₹ ${formatPrice(largest.expectedPrice)}`
                  )
                ) : smallest?.expectedPrice > 0 ? (
                  `₹ ${formatPrice(smallest.expectedPrice)}`
                ) : (
                  `₹ ${formatPrice(largest.expectedPrice)}`
                )}</p>
              </div>
            </div>
          })
        )}
      </div>
    </section>
  );
};

export default PremiumPicks;
